import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import Slider from 'react-slick';

import { CarouselNextArrow } from '../components/CarouselNextArrow';
import { CarouselPrevArrow } from '../components/CarouselPrevArrow';
import { LevelCard, LevelCardProps } from './LevelCard';

export interface LevelCarouselProps {
  levels: Level[];
  currentLevelIndex?: number;
  exampleBg?: boolean;
  slidesToShow?: number;
  centerMode?: boolean;
  className?: string;
}

type Level = LevelCardProps | null;

export const LevelCarousel: React.FC<LevelCarouselProps> = (props) => {
  return (
    <>
      <div className="d-none d-xl-block">
        <LevelCarouselContent {...props} centerMode />
      </div>
      <div className="d-block d-xl-none">
        <LevelCarouselContent
          {...props}
          slidesToShow={1}
          centerMode={false}
          className="levels-carousel-xs"
        />
      </div>
    </>
  );
};

const LevelCarouselContent: React.FC<LevelCarouselProps> = (props) => {
  const slidesToShow = props.slidesToShow || 3;
  const centerMode = props.centerMode;
  const currentLevelIndex = props.currentLevelIndex || 0;
  const slider = useRef<Slider>(null);

  let slides = props.levels || [];
  if (centerMode) {
    slides = slides.concat([null, null]);
  } /** workaround: overcome not going to last element */

  useEffect(() => {
    if (slider.current) {
      slider.current.slickGoTo(currentLevelIndex);
    }
  }, [slider, currentLevelIndex]);

  const settings = {
    arrows: true,
    centerMode,
    centerPadding: '90px',
    infinite: false,
    speed: 600,
    slidesToShow,
    slidesToScroll: 1,
    nextArrow: <CarouselNextArrow />,
    prevArrow: <CarouselPrevArrow />,
  };

  return (
    <Slider
      {...settings}
      className={classNames('levels-carousel', props.exampleBg && 'example-bg', props.className)}
      ref={slider}
    >
      {slides.map((slide, key) => {
        if (!slide) {
          return <div key={key} />;
        } /** workaround: overcome not going to last element */
        return (
          <div key={key}>
            <div className="slide-content">
              <div className="level-wrapper">
                <LevelCard
                  buttonText={slide.buttonText}
                  buttonHref={slide.buttonHref}
                  imgSrc={slide.imgSrc}
                  size="md"
                  status={slide.status}
                  title={slide.title}
                />
              </div>
            </div>
          </div>
        );
      })}
    </Slider>
  );
};
